import { SystemMessage } from 'components/Dialogue';
import { BaseSysMsgProps } from './types';
import dayjs from 'lib/dayjs';
import { useTranslate } from '@tolgee/react';
import { memo } from 'react';

export const SysForceAcquireControlMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { sysForceAcquireControlContent } = raw;
  const { t } = useTranslate();

  return sysForceAcquireControlContent ? (
    <SystemMessage>
      {dayjs(Number(sysForceAcquireControlContent.timestamp)).format('YYYY-MM-DD HH:mm')}
      {t('todo.x因处理y进入会话', {
        x: sysForceAcquireControlContent.assistantName,
        y: {
          PROCESS_TODO: t('todo.待办'),
          PROCESS_REFUND_OR_RETURN: t('domain.order.status.abandoned'),
          PROCESS_RATING: t('domain.review.field.review'),
        }[sysForceAcquireControlContent.reason],
      })}
    </SystemMessage>
  ) : null;
});
